// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Registration_wrapper__1WNWV","success":"Registration_success__dm8ce"};